import Api from '../../api'
import { call, put, takeLatest } from 'redux-saga/effects'
import { LOGOUT } from 'portal-modules/auth/redux/modules/user'
import createRequestSaga from 'portal-modules/common/redux/create-request-saga'
import createFormAction from 'portal-modules/common/redux/create-form-action'
import { addSettings } from 'portal-modules/common/redux/modules/settings'

// action types
const REQUEST_ROOMMATE_INTERESTS =
  'rp/roommate_interests/REQUEST_ROOMMATE_INTERESTS'
const RECEIVE_ROOMMATE_INTERESTS =
  'rp/roommate_interests/RECEIVE_ROOMMATE_INTERESTS'
const SAVE_ROOMMATE_INTERESTS = 'rp/roommate_interests/SAVE_ROOMMATE_INTERESTS'
const PROFILE_UPDATED = 'rp/roommate_interests/PROFILE_UPDATED'

// reducer
export default (state = {}, { payload, type }) => {
  switch (type) {
    case RECEIVE_ROOMMATE_INTERESTS:
    case PROFILE_UPDATED:
      return { ...state, ...payload }
    case LOGOUT:
      return {}
    default:
      return state
  }
}

// action creators
export const requestRoommatePreferences = () => ({
  type: REQUEST_ROOMMATE_INTERESTS,
})

export const saveRoommatePreferences = createFormAction(SAVE_ROOMMATE_INTERESTS)

// sagas
function* fetchRoommatePreferences() {
  const { roommate_interests, settings } = yield call(
    Api.getRoommateInterestsWithSettings,
  )

  yield put({
    type: RECEIVE_ROOMMATE_INTERESTS,
    payload: roommate_interests,
  })
  if (settings) {
    yield put(addSettings({ roommatePreferences: settings }))
  }
}

function* postRoommatePreferences({ payload }) {
  const interestData = {
    applicant_roommate_interests: JSON.stringify(payload),
  }
  yield call(Api.saveRoommateInterests, interestData)
  yield put({ type: REQUEST_ROOMMATE_INTERESTS })
}

function* watchRequestRoommatePreferences() {
  yield takeLatest(
    REQUEST_ROOMMATE_INTERESTS,
    createRequestSaga(fetchRoommatePreferences, {
      key: 'RoommatePreferences',
      message: __('Looking for Roommate Preferences'),
    }),
  )
}

function* watchSaveRoommatePreference() {
  yield takeLatest(
    SAVE_ROOMMATE_INTERESTS,
    createRequestSaga(postRoommatePreferences, {
      key: 'RoommatePreferences',
      message: __('Syncing changes'),
      successMessage: __('Roommate preferences saved successfully'),
      write: true,
    }),
  )
}

export const sagas = [
  watchRequestRoommatePreferences,
  watchSaveRoommatePreference,
]
